import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const salesApi = createApi({
  reducerPath: 'salesApi',
  baseQuery: fetchBaseQuery({
    credentials: 'include',
  }),
  tagTypes: ['SalesFormData'],
  endpoints: (builder) => ({
    postSalesForm: builder.mutation({
      query: (salesFormData) => ({
        url: '/api/sales',
        method: 'POST',
        body: salesFormData,
      }),
      transformErrorResponse: (response, meta) => ({
        ...response,
        xRequestId: meta && meta.response ? meta.response.headers.get('x-request-id') : undefined,
      }),
    }),
  }),
});

export const { usePostSalesFormMutation } = salesApi;
